// ----------------------------------------------------------------------------
// Component: Collection Product Driver
// ----------------------------------------------------------------------------
//
// A grid of products with add to cart functionality.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import '../../snippets/_containers/modal/modal';
import './_collection-product-driver.scss';

const CARD_SELECTOR = '.js--card-recharge';
const PRODUCT_FORM_SELECTOR = '.shopify-product-form';
const RC_FORM_SELECTOR = '.js--card-recharge .shopify-product-form';
const RC_WIDGET = '.js--card-recharge .rc-widget';


function initCollectionProducts() {
    // Select all cards containing the product forms
    const productForms = document.querySelectorAll(RC_FORM_SELECTOR);

    function checkAndCreateWidgets() {
        if (window.ReChargeWidget?.createWidgets) {
            const configs = [];
            productForms?.forEach((form, index) => {
                const productId = form?.dataset.productFormId;
                const config = {
                    productId: parseInt(productId),
                    injectionParent: `.rc-widget-injection-parent-${productId}`, // The node that will have the widget injected in
                    injectionMethod: 'append', // How will the widget be injected
                    selectors: {
                        price: [`.product__price-${productId}`], // the selectors that will be updated based on subscription
                        variant: [`.rc-widget-variant--${productId}`] // The variants to watch for to update the subscription prices
                    },
                    // Runs a custom injection function
                    injectFn: (node, target) => {
                        if (target) {
                            target.insertBefore(node, target.firstChild);
                            console.log("Widget injected successfully:", node);

                        } else {
                            console.error("Target not found for injection");
                        }
                    }
                };
                configs.push(config);
            });

            ReChargeWidget.createWidgets(configs);

        } else {
            setTimeout(checkAndCreateWidgets, 500); // Poll every 500ms until the widget is ready
        }
    }

    checkAndCreateWidgets();
}

document.addEventListener('DOMContentLoaded', function() {
    initCollectionProducts();
});

window.addEventListener('ReChargeWidget-loaded', function() {
    console.log('ReChargeWidget-loaded');

    setTimeout(() => {
        // Your code here
        const productForms = document.querySelectorAll(RC_FORM_SELECTOR);

        productForms?.forEach((form, index) => {
            const subSaveContainer = form.querySelector('.rc-selling-plans ');
            const subscriptionContent = form.querySelector('.subscription-content');
            const oneTimeContainer = form.querySelector('[data-selector-onetime]');
            const oneTimeLabel = form.querySelector('[data-label-text-onetime]');
            const onetimeContent = form.querySelector('.onetime-content');
            const onetimeSubtitle = form.querySelector('.onetime-subtitle');

            subSaveContainer.prepend(subscriptionContent);
            oneTimeContainer.append(onetimeContent);
            oneTimeLabel.append(onetimeSubtitle);

            subscriptionContent.style.display = 'block';
            onetimeSubtitle.style.display = 'block';
        });
    }, 800);


});
